module.exports = __webpack_public_path__ + "img/positive.9229f61d.png";